export const LEVEL_STARTED_LEVEL_1 = 'level.started_level_1';
export const LEVEL_UPDATE_MISSIONS = 'level.UPDATE_MISSIONS';
export const LEVEL_COMPLETED = 'level.COMPLETED';
export const LEVEL_GO_TO_NEW_LEVEL = 'level.GO_TO_NEW_LEVEL';
export const LEVEL_CREATE_NEW_GAME = 'level.CREATE_NEW_GAME';
export const LEVEL_LOAD_GAME = 'level.LOAD_GAME';
export const LEVEL_FAILED = 'level.FAILED';
export const LEVEL_CONTINUE_FAILED = 'level.CONTINUE_FAILED_MISSIONS';
